import PropTypes from "prop-types";
import React, { Component } from "react";
import {
  Button,
  Container,
  Input,
  Header,
  Modal,
  Icon,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility
} from "semantic-ui-react";
import AudioPlayer from "react-h5-audio-player";
import "./player-css.css";

import "semantic-ui-css/semantic.min.css"
import { Router, Link } from "@reach/router";
import Products from "../Products/ProductListing";
import Mixtapes from "../MixtapesListing";
import Tags from "../AllTags";
import { RuntimeTag } from "../../templates/spa-tag";
import { CartPage } from "../../templates/cart-page";

import { SPALandingPage } from "../../templates/spa-landing-page";
import { RuntimeProduct } from "../../templates/product-page";
import { RuntimeMixtape } from "../../templates/mixtape-page";
import { RuntimeBlog } from "../../templates/spa-blog-post";
import { SPAAboutPage } from "../../templates/spa-about-page";
import { ContactPageTemplate } from "../../templates/contact-page";
import { LoginPageTemplate } from "../../templates/login-page";
import { SignupPageTemplate } from "../../templates/signup-page";
import BlogRoll from "../BlogRoll";
import Footer from "../Footer";
import { gmgtStore, mixCloud } from "../../util/social";
import NoSSR from "react-no-ssr";
import banner from './banner.svg'


// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === "undefined";

  return isSSR ? Responsive.onlyMobile.maxWidth : window.innerWidth;
};

/* eslint-disable react/no-multi-comp */

/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */
class HomepageHeading extends Component {
  state = {};

  render() {
    return <Container text>
      <Header
        as='h2'
        content='Good Music Good Times'
        inverted
        style={{
          fontSize: this.props.mobile ? "2em" : "4em",
          fontFamily: "Optima",
          marginBottom: 0,
          color:"white",
          fontWeight: "normal",
          textShadow: "1px 3px 3px #969696, 1px 13px 5px #0c0c0c",
          marginTop: this.props.mobile ? "1.5em" : "3em"
        }}
      />

      <Header
        as='h2'
        content='Where The Culture Lives.'
        inverted
        style={{
          fontSize: this.props.mobile ? "1.5em" : "1.7em",
          fontWeight: "normal",
          textShadow: "1px 3px 3px #969696, 1px 13px 5px #0c0c0c",
          color:"white",
          marginTop: this.props.mobile ? "0.5em" : "1.5em"
        }}
      />
      <AudioPlayer
        autoPlay={false}
        showSkipControls={false}
        showJumpControls={false}
        showFilledProgress={true}
        customAdditionalControls={[]}
        customVolumeControls={[]}
        showDownloadProgress={false}
        src="https://s3.radio.co/sf67c80852/listen"
        onPlay={e => console.log("onPlay")}
        style={{ borderWidth: "0px" }}
        // other props here
      />
    </Container>;
  }
}

HomepageHeading.propTypes = {
  mobile: PropTypes.bool
};

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 * background-color: #FEE140;
background-color: #FEE140;
background-image: linear-gradient(0deg, #FEE140 0%, #FA709A 100%);

 */
class DesktopContainer extends Component {
  state = { fixed: false };

  hideFixedMenu = () => this.setState({ fixed: false });
  showFixedMenu = () => this.setState({ fixed: true });

  handleItemClick = (e, { name }) => this.setState({ activeItem: name });
  handlePasswordConfirmaitonChange = e => {
    this.setState({ 'confirmedPassword': e.target.value });
  };
  render() {
    const { fixed } = this.state;

    return (
      <Responsive
        getWidth={getWidth}
        minWidth={Responsive.onlyTablet.minWidth}
      >
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >


          <Segment
            inverted
            textAlign='center'
            style={{
              minHeight: 600,
              background: `url(${banner}) `+", linear-gradient(to right,  #0093E9 0%, #80D0C7 100%) ",
              backgroundSize:'contain',
              borderBottom: "0 none !important",
              boxShadow: "none"
            }}
            vertical
          >
            <Menu
              fixed={fixed ? "top" : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              style={{ borderWidth: "0px", boxShadow: "none" }}
              borderless={true}
              size='large'
            >
              <Container>
                <Menu.Item as={Link} to="/">HOME</Menu.Item>
                <Menu.Item as={Link} to="news">NEWS</Menu.Item>
                <Menu.Item href={mixCloud} target="_blank">WATCH LIVE</Menu.Item>
                <Menu.Item href={gmgtStore} target="_blank">SHOP</Menu.Item>
                <Menu.Item as={Link} to="mixtapes">MIXTAPES</Menu.Item>
                <Menu.Item as={Link} to="abouts">ABOUT</Menu.Item>
                <Menu.Item to="contacts" as={Link}>CONTACT</Menu.Item>

                <Menu.Item position='right'>
                  <Button as={Link} to="login" inverted={!fixed} style={{ marginLeft: "0.5em" }}>
                    Log in
                  </Button>
                  <Button as={Link} to="signup" inverted={!fixed} primary={fixed} style={{ marginLeft: "0.5em" }}>
                    Sign Up
                  </Button>
                </Menu.Item>
              </Container>
            </Menu>
            <HomepageHeading/>
          </Segment>
        </Visibility>
        {router}
        <Footer/>
      </Responsive>
    );
  }
}

const router = (
  <Router>
    <SPALandingPage default/>
    <BlogRoll path="news"/>
    <RuntimeBlog path="news/:blogId"/>
    <Products path='products'/>
    <RuntimeProduct path={"products/:productId"}/>
    <Mixtapes path={"mixtapes"}/>
    <CartPage path={"cart"}/>
    <RuntimeMixtape path={"mixtapes/:mixtapeId"}/>
    <SignupPageTemplate path={"signup"}/>
    <LoginPageTemplate path={"login"}/>
    <SPAAboutPage path="abouts"/>
    <ContactPageTemplate path="contacts"/>
    <Tags path={"tag"}/>
    <RuntimeTag path={"tag/:tagId"}/>
  </Router>
);

DesktopContainer.propTypes = {
  children: PropTypes.node
};

class MobileContainer extends Component {
  // const url = typeof window !== 'undefined' ? window.location.href : '';
  state = { activeItem: "" };

  handleSidebarHide = () => this.setState({ sidebarOpened: false });

  handleToggle = () => this.setState({ sidebarOpened: true });
  handleItemClick = (e, { name }) => this.setState({ activeItem: name });


  render() {
    const { sidebarOpened } = this.state;

    return (

      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation='push'
          style={{ borderWidth: "0px none !important", boxShadow: "none" }}
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item as={Link} onClick={this.handleSidebarHide} to="/">HOME</Menu.Item>
          <Menu.Item as={Link} onClick={this.handleSidebarHide} to="news">NEWS</Menu.Item>
          <Menu.Item href={mixCloud} target="_blank">WATCH LIVE</Menu.Item>
          <Menu.Item href={gmgtStore} target="_blank">SHOP</Menu.Item>
          <Menu.Item as={Link} onClick={this.handleSidebarHide} to="mixtapes">MIXTAPES</Menu.Item>
          <Menu.Item as={Link} onClick={this.handleSidebarHide} to="abouts">ABOUT</Menu.Item>
          <Menu.Item to="contacts" onClick={this.handleSidebarHide} as={Link}>CONTACT</Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            style={{
              minHeight: 350,
              padding: "1em 0em",
              background: "linear-gradient(to right,  #0093E9 0%, #80D0C7 100%)"
            }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size='large' style={{ borderWidth: "0px", boxShadow: "none" }}>
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name='sidebar'/>
                </Menu.Item>
                <Menu.Item position='right'>
                  <Button as={Link} to="login" inverted={true}>
                    Log in
                  </Button>
                  <Button as={Link} to="signup" inverted={true} style={{ marginLeft: "0.5em" }}>
                    Sign Up
                  </Button>
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile/>
          </Segment>
        </Sidebar.Pusher>
        {router}
        <Footer/>
      </Responsive>
    );
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node
};

const ResponsiveContainer = ({ children }) => (
  <div>
    <MobileContainer>{children}</MobileContainer>
    <NoSSR>
      <DesktopContainer>{children}</DesktopContainer>
    </NoSSR>
  </div>
);

ResponsiveContainer.propTypes = {
  children: PropTypes.node
};


export default ResponsiveContainer;
export { DesktopContainer, MobileContainer };
